import {
    Burger,
    Button,
    Container,
    Drawer,
    Group,
    Stack,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconPhone } from '@tabler/icons-react';
import { Link, useLocation } from 'react-router';
import classes from './Header.module.css';

const links = [
  { link: '/', label: 'Home' },
  { link: '/facility', label: 'Facility' },
  { link: '/services', label: 'Services' },
  { link: '/staffing', label: 'Expert Staffing' },
  { link: '/about', label: 'About Us' },
  { link: '/contact', label: 'Contact' },
];

export function Header() {
  const [opened, { toggle, close }] = useDisclosure(false);
  const location = useLocation();

  const items = links.map((link) => (
    <Link
      key={link.label}
      to={link.link}
      className={classes.link}
      data-active={location.pathname === link.link || undefined}
      onClick={close}
    >
      {link.label}
    </Link>
  ));

  return (
    <Container size="xl" h="100%">
      <a href="#main-content" className={classes.skipLink}>
        Skip to main content
      </a>
      <Group h="100%" justify="space-between">
        <Link to="/" className={classes.logo}>
          <img
            src="/hillside-harmony-transparent.jpeg"
            alt="Hillside Harmony"
            style={{ height: 50 }}
          />
        </Link>
        <Group gap="sm" visibleFrom="sm">
          <Group gap={0} component="nav" aria-label="Main navigation">{items}</Group>
          <Button
            component="a"
            href="tel:+16514000063"
            leftSection={<IconPhone size={16} />}
            variant="filled"
          >
            (651) 400-0063
          </Button>
        </Group>

        <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" aria-label="Open navigation menu" />
      </Group>

      <Drawer
        opened={opened}
        onClose={close}
        title="Hillside Harmony"
        padding="md"
        size="xs"
        position="right"
      >
        <Stack gap="md">
          {items}
          <Button
            component="a"
            href="tel:+15551234567"
            leftSection={<IconPhone size={16} />}
            variant="filled"
            fullWidth
            mt="md"
          >
            Call Us
          </Button>
        </Stack>
      </Drawer>
    </Container>
  );
}
